import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BarIvaFiscalPorEmpresa from '../BarIvaFiscalPorEmpresa/BarIvaFiscalPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartIvaFiscalPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <BarIvaFiscalPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Iva fiscal por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalIvas)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.ivas}
                onChangeViewClick={handleChangeView}
                title={`Iva fiscal por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalIvas)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
        ivas: state.multiempresa.ivaFiscalPorEmpresa.ivas,
        totalIvas: state.multiempresa.ivaFiscalPorEmpresa.totalIvas,
        loading: state.multiempresa.ivaFiscalPorEmpresa.loading,
        estaCargado: state.multiempresa.ivaFiscalPorEmpresa.estaCargado,
        estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.ivaFiscalMultiempresa
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadIvaFiscalPorEmpresa())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartIvaFiscalPorEmpresa);